import icon1 from '../images/icon/research.gif'
import icon2 from '../images/icon/faq.gif'
import icon3 from '../images/icon/folder.gif'
import icon4 from '../images/icon/chat.gif'
import icon5 from '../images/icon/phone-contact.gif'
import icon6 from '../images/icon/warning.gif'

import sicon1 from '../images/icon/ser-icon01.svg'
import sicon2 from '../images/icon/ser-icon02.svg'
import sicon3 from '../images/icon/ser-icon03.svg'
import sicon4 from '../images/icon/ser-icon04.svg'

import sdicon1 from '../images/icon/encryption_02.png'
import sdicon2 from '../images/icon/security_01.png'
import sdicon3 from '../images/icon/authentication_01.png'
import sdicon4 from '../images/icon/notification_01.png'

import simg1 from '../images/service/service-img02.jpg'
import simg2 from '../images/service/service-img01.jpg'
import simg3 from '../images/service/service-img03.jpg'
import simg4 from '../images/service/service-img04.jpg'


import scicon1 from '../images/icon/airdrop-white.svg'
import scicon2 from '../images/icon/cloud-add.svg'
import scicon3 from '../images/icon/check02.svg'
import scicon4 from '../images/icon/finger-scan.svg'
import scicon5 from '../images/icon/ranking.svg'


import cdicon1 from '../images/icon/cd-ser_icon01.svg'
import cdicon2 from '../images/icon/cd-ser_icon02.svg'
import cdicon3 from '../images/icon/cd-ser_icon03.svg'
import cdicon4 from '../images/icon/cd-ser_icon04.svg'
import cdicon5 from '../images/icon/cd-ser_icon05.svg'
import cdicon6 from '../images/icon/cd-ser_icon06.svg'
import cdicon7 from '../images/icon/cd-ser_icon08.svg'
import cdicon8 from '../images/icon/cd-ser_icon09.svg'



const Services = [
    {
        Id: '1',
        sImg: icon1,
        title: 'KYC Upload',
        slug: 'KYC Upload',
        thumb1: 'Strategy',
        thumb2: 'Consultation',
        description: 'Quick, secure, and fully compliant with international remittance standards.',
    },
    {
        Id: '2',
        sImg: icon2,
        title: 'Onboarding FAQs',
        slug: 'Onboarding FAQs',
        thumb1: 'Management',
        thumb2: 'Transfer',
        description: 'Your Questions Answered – Start Sending Money with Confidence',
    },
    {
        Id: '3',
        sImg: icon3,
        title: 'Data Safty',
        slug: 'Data Safty',
        thumb1: 'Landing Page',
        thumb2: 'Plugins',
        description: ' At TigrisPay, safeguarding your information is our highest priority.',
    },
    {
        Id: '4',
        sImg: icon4,
        title: 'General FAQs',
        slug: 'General FAQs',
        thumb1: 'Consultation',
        thumb2: 'solution',
        description: 'Frequently Asked Questions',
    },
    {
        Id: '5',
        sImg: icon5,
        title: 'Contact Info',
        slug: 'Contact Info',
        thumb1: 'Website',
        thumb2: 'Mobile App',
        description: 'Need Help? We’re Here for You.',
    },
    {
        Id: '6',
        sImg: icon6,
        title: 'Penalty recovery',
        slug: 'Penalty-recovery',
        description: 'Penalty recovery fixes issues that caused search engine penalty to restore rankings.',
    },
    {
        Id: '7',
        sImg: simg1,
        sIcon: sicon1,
        title: 'IT management',
        slug: 'IT-management',
    },
    {
        Id: '8',
        sImg: simg2,
        sIcon: sicon2,
        title: 'Data tracking & security',
        slug: 'Data-tracking-&-security',
    },
    {
        Id: '9',
        sImg: simg3,
        sIcon: sicon3,
        title: 'Custom CRM services',
        slug: 'Custom-CRM-services',
    },
    {
        Id: '10',
        sImg: simg4,
        sIcon: sicon4,
        title: 'Website development ',
        slug: 'Website-development ',
    },
    
       {
    Id: '11',
    sIcon: sdicon1,
    title: 'Transfers Are Always Protected',
    slug: 'secure-transfers',
    description: 'Every time you send money, we lock it down with advanced encryption. This means your details are safe from start to finish — no one else can see or touch them.',
},
{
    Id: '12',
    sIcon: sdicon2,
    title: 'We Verify So You Can Trust',
    slug: 'identity-check',
    description: 'Before sending money, we securely verify your identity to prevent fraud. It’s quick, easy, and keeps you and your money safe — without ever sharing your personal info without permission.',
},
{
    Id: '13',
    sIcon: sdicon3,
    title: 'Extra Layer of Login Security',
    slug: 'safe-login',
    description: 'Logging in to your account takes just a moment longer — and that’s a good thing. With two-step login, only you can access your account, even if someone knows your password.',
},
{
    Id: '14',
    sIcon: sdicon4,
    title: 'We Alert You Instantly',
    slug: 'instant-alerts',
    description: 'If anything unusual happens — like a login from a new device — we’ll let you know right away. You’re always in control and aware of what’s happening with your account.',
},

    {
        Id: '15',
        sIcon: scicon1,
        title: 'Secure your network',
        slug: 'Secure-your-network',
        features: [' Consistently Secure the Enterprise.', 'Apply Al inline to prevent evasive.', 'Simplify network security operations.', ' Adopt Zero Trust across the network.', ' Simplify with AI-Powered SASE.']
    },
    {
        Id: '16',
        sIcon: scicon2,
        title: 'Secure your cloud',
        slug: 'Secure-your-cloud',
        features: ['End-to-End Cloud Security.', 'Real-Time Threat Detection.', 'Identity & Access Management.', 'Data Encryption & Privacy.', 'Compliance & Governance.']
    },
    {
        id: '17',
        sIcon: scicon3,
        title: 'Transform your SOC',
        slug: 'Transform-your-SOC',
        features: [
            'Accelerate Threat Detection',
            'Automate Security Processes',
            'Streamline Incident Response',
            'Attack Surface Management',
            'Integrated Security Monitoring',
        ],
    },
    {
        id: '18',
        sIcon: scicon4,
        title: 'Threat Intel & Response',
        slug: 'Threat-Intel-&-Response',
        features: [
            "Let our experts be of your team.",
            "Move from reactive to proactive.",
            "Get world-class threat intelligence",
            "Every second counts when attack",
            "Make our experience your experience",
        ],
    },
    {
        id: '19',
        sIcon: scicon5,
        title: 'Solutions by industry',
        slug: 'Solutions-by-industry',
        features: [
            'Public sector',
            'Financial services',
            'Manufacturing',
            'Small & medium business solutions',
            'Healthcare',
        ],
    },

    {
        Id: '20',
        sIcon: cdicon1,
        title: 'INFRASTRUCT URE DESIGN',
        slug: 'INFRASTRUCT-URE-DESIGN',
    },
    {
        Id: '21',
        sIcon: cdicon2,
        title: 'COSTS OPTIMIZATION',
        slug: 'COSTS-OPTIMIZATION',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '22',
        sIcon: cdicon3,
        title: 'INFRASTRUCTURE AS A CODE',
        slug: 'INFRASTRUCTURE-AS-A-CODE',
        bgClass:'cd-dot_bg3',
    },
    {
        Id: '23',
        sIcon: cdicon4,
        title: 'Continuous Integration',
        slug: 'Continuous-Integration',
        bgClass:'cd-dot_bg4',
    },
    {
        Id: '24',
        sIcon: cdicon5,
        title: 'Continuous Deployment',
        slug: 'Continuous-Deployment',
    },
    {
        Id: '25',
        sIcon: cdicon6,
        title: 'Blue Green Deployment',
        slug: 'Blue-Green-Deployment',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '26',
        sIcon: '',
        title: 'Data Consistency',
        slug: 'Data-Consistency',
        bgClass:'cd-dot_bg3'
    },
    {
        Id: '27',
        sIcon: cdicon7,
        title: 'Data Integrity',
        slug: 'Data-Integrity',
        bgClass:'cd-dot_bg4'
    },
    {
        Id: '28',
        sIcon: cdicon8,
        title: 'Redundancy',
        slug: 'Redundancy',
    },
]

export default Services;